import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterDashboard() {
        return axiosJwt.get(`${api}/home/dashboard`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }
}
